import axios from './http'

const SYNC_TIMEOUT = 15 * 60 * 1000

export default {
    syncPricesToCipher() {
        return axios.get('/v1/sync/prices-to-cipher', { timeout: SYNC_TIMEOUT })
    },
    syncPricesToSalesOps() {
        return axios.get('/v1/sync/prices-to-salesop', { timeout: SYNC_TIMEOUT })
    }
}
